import {Component, Input, ViewEncapsulation} from '@angular/core';
import {NotificationComponentObject} from "../../../classes/notification-component-object";
import {Serializer} from "../../../interfaces/serializer";
import {DataSource} from "../../../interfaces/data-source";
import {Site} from "../../../interfaces/site";
import {NotificationDataSourceTemplateStore} from "./notification-data-source-template.store";

@Component({
  selector: 'app-notification-data-source-template',
  templateUrl: './notification-data-source-template.component.html',
  styleUrls: ['./notification-data-source-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [NotificationDataSourceTemplateStore]
})
export class NotificationDataSourceTemplateComponent {
  @Input('notification') public set set_notification(notification: NotificationComponentObject) {
    this.notification = notification;
    this.data_set_usages = notification.payload.relationships.models.data.filter(item => item.type === 'data_set_usage');
    this.data_set = notification.payload.relationships.data_set.data;
  }

  public notification: NotificationComponentObject;
  public data_set_usages: Serializer<DataSource>;
  public data_set: Serializer<Site>;

  constructor(
    private readonly _notificationDataSourceTemplateStore: NotificationDataSourceTemplateStore
  ) { }

  public onReconnectClick(): void {
    this._notificationDataSourceTemplateStore.onReconnectClick({
      site: this.data_set,
      data_set_usages: this.data_set_usages,
      notification: this.notification
    });
  }
}
